<template>
	<div>
		<div class="content">
			<!-- 今日排查分析情况 -->
			<div id="todayScreeningAnalysis">
				<div class="title">
					<div class="leftSquare"></div>
					<div class="text">今日排查分析情况</div>
				</div>

				<div class="todayBox">
					<div id="todayPieChart"></div>
				</div>
			</div>
			<!-- 今日排查分析情况 -->
		</div>
	</div>
</template>
<script>
	import {
		apiurl,
		imgurl
	} from '../../common/js/baseApi.js'
	import axios from 'axios'
	export default {
		components: {},
		data() {
			return {
				pId: '', // 用户id
				isShow: true, // 是否显示
				nowClientWidth: 1920 // 默认屏幕宽度
			}
		},
		computed: {},
		watch: {},
		methods: {
			getDataDay() {
				axios.get(apiurl + '/index/totalByPlanNum', {
						params: {
							pId: this.pId,
							type: 1
						}
					})
					.then(data => {
						if (data.data.status != 1) {
							return
						}
						let res = data.data.data
						if (res.num1 == 0 && res.num0 == 0) {
							this.isShow = false
						}
						let myChart = this.$echarts.init(document.getElementById('todayPieChart'))
						let option = {
							tooltip: {
								trigger: 'item',
								textStyle: {
									fontSize: this.nowSize(12)
								},
								formatter: '{b} : {c} {d}%'
							},
							legend: {
								left: this.nowSize(80),
								top: this.nowSize(12),
								itemWidth: this.nowSize(28),
								itemHeight: this.nowSize(14),
								orient: 'vertical',
								itemGap: this.nowSize(16),
								textStyle: {
									color: "#fff",
									fontSize: this.nowSize(12)
								}
							},
							series: [{
								type: 'pie',
								radius: ['40%', '70%'],
								itemStyle: {
									borderRadius: this.nowSize(5),
									borderWidth: this.nowSize(2)
								},
								avoidLabelOverlap: true,
								label: {
									show: true,
									formatter: '{b} : {c}',
									color: "#fff",
									fontSize: this.nowSize(12)
								},
								labelLine: {
									show: true,
									length: this.nowSize(15),
									length2: this.nowSize(15),
									lineStyle: {
										width: this.nowSize(1)
									}
								},
								data: [{
										name: '已排查',
										value: res.num1
									},
									{
										name: '未排查',
										value: res.num0
									}
								]
							}]
						}

						myChart.setOption(option);
					})
					.catch(err => {

					})
			},
			nowSize(val, initWidth = 1920) {
				return val * (this.nowClientWidth / initWidth);
			}
		},
		created() {},
		mounted() {
			this.nowClientWidth = document.documentElement.clientWidth;
			var url = window.location.search
			var theRequest = new Object()
			if (url.indexOf('?') != -1) {
				var str = url.split('?')[1]
				var strs = str.split('&')
				for (var i = 0; i < strs.length; i++) {
					theRequest[strs[i].split('=')[0]] = (strs[i].split('=')[1])
				}
			}
			this.pId = theRequest.pId
			this.getDataDay()
		},
		beforeCreate() {},
		beforeMount() {},
		beforeUpdate() {},
		updated() {},
		beforeDestroy() {},
		destroyed() {},
		activated() {},
	}
</script>
<style lang='scss' scoped>
	@mixin titleStyle {
		.title {
			position: absolute;
			left: 0;
			top: -0.625rem;
			display: flex;
			align-items: center;

			.leftSquare {
				width: 0.25rem;
				height: 1.25rem;
				background-color: #00EAFF;
				margin-right: 0.875rem;
			}

			.text {
				font-size: 1.25rem;
				color: #00EAFF;
			}
		}
	}

	.content {
		width: 33.5rem;
		height: 11.875rem;
		background: url(../../common/img/leftCenter/bg.png) 0 0 no-repeat;
		background-size: 100% 100%;

		/* 今日排查分析情况 */
		#todayScreeningAnalysis {
			position: relative;
			width: 100%;
			height: 100%;

			@include titleStyle;

			.todayBox {
				display: flex;
				align-items: center;
				justify-content: center;
				box-sizing: border-box;
				margin-top: 0.625rem;
				width: 100%;
				height: 100%;

				#todayPieChart {
					padding-top: 0.625rem;
					width: 100%;
					height: 100%;
					box-sizing: border-box;
				}
			}
		}

		/* 今日排查分析情况 */
	}
</style>



// WEBPACK FOOTER //
// src/components/leftCenter/index.vue